import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const FlayoutContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  animation: ${fadeDown} 0.5s ease-out;
  background-color: rgba(0, 0, 0, 0.65);

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0;

  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
`;

const OverlaySavingCalculatorModal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const body = document.body;
    if (!body) return;

    if (isOpen) {
      const prev = body.style.overflowY;
      body.dataset.prevOverflowY = prev || '';
      body.style.overflowY = 'hidden';
    } else if (body.dataset.prevOverflowY !== undefined) {
      body.style.overflowY = body.dataset.prevOverflowY || 'auto';
      delete body.dataset.prevOverflowY;
    }

    return () => {
      if (body.dataset.prevOverflowY !== undefined) {
        body.style.overflowY = body.dataset.prevOverflowY || 'auto';
        delete body.dataset.prevOverflowY;
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <FlayoutContainer
      onClick={() => {
        if (onClose) onClose();
      }}
    >
      <div
        className='w-full h-full flex items-start justify-center'
        onClick={(e) => e.stopPropagation()}
        style={{ overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}
      >
        {children}
      </div>
    </FlayoutContainer>
  );
};

export default OverlaySavingCalculatorModal;
